export const messages = {
  en: {
    cityArea: {
      areaDetails: 'Area Details',
      areaName: 'Area Name',
      areaCode: 'Area Code',
      areaLevel: 'Level',
      parentAreaCode: 'Parent Code',
      parentAreaName: 'Parent Name',
      createTime: 'Create Time',
      province: 'Province',
      city: 'City',
      district: 'District',
      area: 'Area',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      selectAreaFirst: 'Please select an area first',
      cannotAddChild: 'Cannot add child node',
      addArea: 'Add Area',
      editArea: 'Edit Area',
      areaNameRequired: 'Required, please enter area name',
      areaCodeRequired: 'Required, please enter area code',
      parentRequired: 'Required, please select parent',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteArea: 'Confirm to delete this area?',
      cancel: 'Cancel',
      save: 'Save',
      confirmDelete: 'Confirm Delete',
      addSuccess: 'Add successfully',
      addFailed: 'Add failed',
      editSuccess: 'Edit successfully',
      editFailed: 'Edit failed',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      parent: 'Parent'
    }
  },
  zh: {
    cityArea: {
      areaDetails: '地区详情',
      areaName: '地区名称',
      areaCode: '地区编码',
      areaLevel: '等级',
      parentAreaCode: '父级编码',
      parentAreaName: '父级名称',
      createTime: '创建时间',
      province: '省级',
      city: '市州',
      district: '区县',
      area: '地区',
      add: '添加',
      edit: '修改',
      delete: '删除',
      selectAreaFirst: '请先选择地区',
      cannotAddChild: '不能添加子节点',
      addArea: '添加区域',
      editArea: '修改区域',
      areaNameRequired: '必填，请填写地区名称',
      areaCodeRequired: '必填，请填写地区编码',
      parentRequired: '必填，请选择上级',
      confirmOperation: '请确认您的操作',
      confirmDeleteArea: '确定删除该地区吗？',
      cancel: '取消',
      save: '保存',
      confirmDelete: '确认删除',
      addSuccess: '添加成功',
      addFailed: '添加失败',
      editSuccess: '修改成功',
      editFailed: '修改失败',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      parent: '父级'
    }
  }
}